import { Patient } from "@accurx/api/portal";

export const isTestPatient = (patient?: Nullable<Pick<Patient, "nhsNumber">>) =>
    patient?.nhsNumber === "7777777777";
